"use client";

import { useEffect } from "react";
import type { TrackedPage } from "@/lib/analytics";

export function TrackPage({ page }: { page: TrackedPage }) {
  useEffect(() => {
    const key = "gamevault-visitor";
    let visitor = window.localStorage.getItem(key);
    if (!visitor || !/^[\w-]{8,80}$/.test(visitor)) {
      visitor = crypto.randomUUID();
      window.localStorage.setItem(key, visitor);
    }

    void fetch("/api/analytics", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page, visitor }),
      keepalive: true,
    });
  }, [page]);

  return null;
}
